import script from "./AnalyzeKaoyan.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyzeKaoyan.vue?vue&type=script&setup=true&lang=js"

import "./AnalyzeKaoyan.vue?vue&type=style&index=0&id=136ffd09&lang=scss"

const __exports__ = script;

export default __exports__